const s = {
  name: "Headphones",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M34,34v-4h2v4H34z"/>
		<path class="st0" d="M36,18.2c1.2,0.4,2,1.5,2,2.8s-0.8,2.4-2,2.8v1.3c2.3,0.5,4,2.5,4,4.9v4c0,2.8-2.2,5-5,5h-3v1h-6V24h6v1h2
			v-1.2c-1.2-0.4-2-1.5-2-2.8s0.8-2.4,2-2.8V17h-4v-1c0-5.5-4.5-10-10-10s-10,4.5-10,10v1H6v1.2c1.2,0.4,2,1.5,2,2.8s-0.8,2.4-2,2.8
			V25h2v-1h6v16H8v-1H5c-2.8,0-5-2.2-5-5v-4c0-2.4,1.7-4.4,4-4.9v-1.3c-1.2-0.4-2-1.5-2-2.8s0.8-2.4,2-2.8V16C4,7.2,11.2,0,20,0
			c4.4,0,8.4,1.8,11.3,4.7C34.2,7.6,36,11.6,36,16V18.2z M6,15h2C8.5,8.8,13.7,4,20,4s11.5,4.8,12,11h2c-0.2-3.5-1.8-6.6-4.1-8.9
			l0,0C27.4,3.6,23.9,2,20,2C12.6,2,6.5,7.7,6,15z M30,26h-2v12h2V26z M32,37h3c1.7,0,3-1.3,3-3v-4c0-1.7-1.3-3-3-3h-3V37z M10,38h2
			V26h-2V38z M5,27c-1.7,0-3,1.3-3,3v4c0,1.7,1.3,3,3,3h3V27H5z M5,20c-0.6,0-1,0.4-1,1s0.4,1,1,1s1-0.4,1-1S5.6,20,5,20z M34,21
			c0,0.6,0.4,1,1,1s1-0.4,1-1s-0.4-1-1-1S34,20.4,34,21z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Headphones
};
